module.exports = __webpack_public_path__ + "static/media/campfire.ee83ac02.svg";